import {Delegate} from "../Tools/Delegate.js";

export const OnOtpStrategyAdd = new Delegate();
export const OnOtpStrategyUpdate = new Delegate();
export const OnOtpStrategyDelete = new Delegate();
